<template>
  <main id="app">
    <h2>薪资收益计算器</h2>
    <Calculator/>
    <h2>可视化收益</h2>
    <Charts/>
    <h2>参考</h2>
    <References/>
    <h2>公式源代码</h2>
    <Formula/>
  </main>
</template>

<script>
import Calculator from "./components/Calculator";
import Charts from "./components/Charts";
import References from "./components/References";
import Formula from "./components/Formula";

export default {
  name: "App",
  components: {
    Calculator,
    Charts,
    References,
    Formula,
  }
};
</script>

<style>
body {
  width: 600px;
  max-width: 100%;
  margin: 48px auto 0;
}

h2 {
  margin: 48px 0;
  text-align: center;
}

input,textarea {
  border: 0;
  -webkit-appearance: none;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: hsl(200, 1%, 20%);
  margin-top: 60px;
}
</style>
